import { render } from "./UsageTest.vue?vue&type=template&id=56fdfa0e"
import script from "./UsageTest.vue?vue&type=script&lang=js"
export * from "./UsageTest.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__